import React, { useEffect, useState } from 'react';
import DashboardLayout from './DashboardLayout.js';
import AdminActivityLog from './AdminActivity/Logs.js';
import baseURL from '../config.js';
import { toast } from 'react-toastify'; // Import toast from react-toastify
import PageLoader from '../../../Reusable/PageLoader.js';

const Log = () => {
    const [activityLogData, setActivityLogData] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const fetchActivityLog = async () => {
            try {
        // await new Promise(resolve => setTimeout(resolve, 4000));

                const response = await fetch(`${baseURL}/admin/activity-log`, {
                    method: "GET",
                    credentials: "include",
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch activity log data");
                }

                const data = await response.json();
                setActivityLogData(data);
            } catch (err) {
                console.error("Error fetching admin activity log:", err);
                toast.error(err.message || "An unexpected error occurred. Please try again."); // Use toast.error for errors
            } finally {
                setLoading(false);
            }
        };

        fetchActivityLog();
    }, []);

    if (loading) {
        return (
            <DashboardLayout>
                <PageLoader message="Loading activity log..." />
            </DashboardLayout>
        );
    }
    
    // The error is now handled by the toast, so we don't need a separate error state or return block.
    // We can simply render the AdminActivityLog component with the data (which might be an empty array on error).

    return (
        <DashboardLayout>
            <AdminActivityLog logData={activityLogData} />
        </DashboardLayout>
    );
};

export default Log;